var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentMultiple01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#document--multiple-01_svg__clip0_61530_7260)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5H1.5v15H3v-15zM6 3H4.5v18H6V3zM19.5 16.5h-9V18h9v-1.5zM19.5 12h-9v1.5h9V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.275 6.975l-5.25-5.25A.68.68 0 0016.5 1.5H9c-.825 0-1.5.675-1.5 1.5v18c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5V7.5a.68.68 0 00-.225-.525zM16.5 3.3l4.2 4.2h-4.2V3.3zM21 21H9V3h6v4.5c0 .825.675 1.5 1.5 1.5H21v12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "document--multiple-01_svg__clip0_61530_7260"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDocumentMultiple01;